import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { stats, configure, searchBox } from 'instantsearch.js/es/widgets/index.js';
import { connectStats, connectInfiniteHits } from 'instantsearch.js/es/connectors/index.js';

export function loadBrandAlgolia() {
    const $brands = document.getElementById('brands');

    if (!$brands) {
        return;
    }

    const algoliaAppId =  $brands.getAttribute('data-app-id');
    const algoliaSearchKey =  $brands.getAttribute('data-search');
    const algoliaIndex =  $brands.getAttribute('data-index');
    const textSearchPlaceholder = $brands.getAttribute('data-text-search');
    const currentLocale = getCurrentLocale();

    // Initialize Algolia Search Client
    const searchClient = algoliasearch(
        algoliaAppId,
        algoliaSearchKey
    );

    // Initialize Algolia InstantSearch
    const search = instantsearch({
        indexName: algoliaIndex,
        searchClient,
        routing: false,
    });

    search.addWidgets([
        configure({
            getRankingInfo: true,
        }),
    ]);

    // Stats
    const customStats = connectStats((renderOptions, isFirstRender) => {
        const { nbHits, hitsPerPage, page, widgetParams } = renderOptions;
        const container = widgetParams.container;
        const progressCounter = document.getElementById('brand-progress-counter');
        const showing = Math.min((page + 1) * hitsPerPage, nbHits);

        if (nbHits && progressCounter) {
            progressCounter.max = parseInt(nbHits);
            progressCounter.value = parseInt(showing);
        }

        container.textContent = `${showing} von ${nbHits} Marken`;
    });

    // Helpers
    function getCurrentLocale() {
        const path = window.location.pathname;
        const pathParts = path.split('/').filter(Boolean);

        // Check for locale in URL path (e.g., /en/, /de/)
        if (pathParts.length > 0) {
            const firstPart = pathParts[0];
            if (firstPart === 'it' || firstPart === 'en' || firstPart === 'fr') {
                return firstPart;
            }
        }

        // Default locale
        return 'de';
    }

     // Custom InfiniteHits with show more button
    let lastRenderArgs;
    const customInfiniteHits =  connectInfiniteHits(
        (renderOptions, isFirstRender, renderArgs) => {
            const { hits, showMore, isLastPage, widgetParams } = renderOptions;

            lastRenderArgs = renderArgs;
            const btnShowMore = document.getElementById('btn-show-more-brands');

            if (isFirstRender) {
                if (btnShowMore) btnShowMore.addEventListener('click', () => showMore());
            }
         
            const hitsHTML = hits
                .map(hit => widgetParams.templates.item(hit))
                .join('');

            const hitsContainer = document.getElementById('brand-hits');
            if (hitsContainer) hitsContainer.innerHTML = hitsHTML;

            // Toggle state load button
            if (btnShowMore) {
                btnShowMore.disabled = isLastPage;
                btnShowMore.textContent = isLastPage ? 'Keine weiteren Marken' : 'weitere Marken anzeigen';
            }
        }
    );


    // Add the SearchBox widget
    search.addWidgets([
        configure({
            getRankingInfo: true,
        }),
        customInfiniteHits({
            container: document.getElementById('brand-hits'),
            templates: {
                item(hit) {
                    return `
                        <div class="tw:group tw:w-full product-card" itemprop="itemListElement" itemscope itemtype="https://schema.org/Brand">
                            <div class="box-image product-small product">
                    
                                <a href="${hit.display_permalink}" title="${hit.name}" class="ais-InfiniteHits-item">
                                    <img class="tw:desktop:rounded-theme" itemprop="logo" src="${hit.image_url}" title="${hit.name}" alt="${hit.image_alt}" onerror="this.onerror=null;this.src='https://placehold.co/200x200/cccccc/333333?text=No+Image';">
                                </a>
                            </div>

                            <div class="tw:pt-4">
                                <p class="name product-title woocommerce-loop-product__title">
                                    <a href="${hit.display_permalink}" class="tw:font-bold tw:text-black tw:hover:text-primary">
                                        <span itemprop="name">${hit.name}</span>
                                    </a>
                                </p>
                                <p class="box-excerpt is-small tw:text-14px tw:text-muted tw:pt-2" itemprop="slogan">${hit.display_content}</p>
                            </div>
                        </div>
                    `;
                },
            },
            transformItems(items) {
                return items.map(item => {
                    item.display_permalink = item[`permalink_${currentLocale}`] || item.permalink_de;
                    item.display_content   = item[`description_${currentLocale}`] || item.description_de || '';
                    return item;
                });
            },
            cssClasses: {
                list: 'tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:lg:grid-cols-3 tw:gap-y-16 tw:gap-x-8',
                item: 'tw:bg-white tw:overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-lg flex flex-col',
                loadMore: 'tw:bg-primary tw:hover:bg-primary-dark tw:button tw:w-full tw:h-16 tw:py-0',
            },
        }),

        customStats({
            container: document.getElementById('brand-all-counter'),
        }),

        searchBox({
            container: '#brand-search',
            placeholder: textSearchPlaceholder,
        }),
    ]);

    search.start();

}